// extracted by mini-css-extract-plugin
export default {"ModalPaper":"Modal_ModalPaper__nREBX","SignInModal":"Modal_SignInModal__JNflB"};